<div class="page-container">
    <app-header title="performance.goal-index.adminIndexTitle" [menuService]="performanceMenuService">
        <div class="buttons">
            <ui-button
                (click)="trackCreatingGoal()"
                type="primary"
                *permission="createPermission"
                [routerLink]="['create']"
            >
                <mat-icon svgIcon="plus"></mat-icon>
                {{ 'performance.goal-index.createGoal' | translate }}
            </ui-button>
        </div>
    </app-header>

    <app-table [table]="table">
        <app-empty-state label="performance.goal-index.noGoalsFound" src="/assets/illustrations/flag.png">
        </app-empty-state>
    </app-table>
</div>
